
export default class KenBurns {
  /**
   * @param {import('../ThemeBase').default} theme
   * @param {HTMLElement} element
   */
  constructor(theme, element) {
    this.theme = theme;
    this.element = element;
    this.load();
  }

  load = () => {
    this.observer = new IntersectionObserver(
      () => {
        this.apply();
      },
      {
        threshold: [1],
      },
    );
    this.observer.observe(this.element);
  }

  apply = () => {
    Array.prototype.forEach.call(
      this.element.querySelectorAll('.kb-enabled'),
      (el, index) => {
        setTimeout(() => {
          el.classList.add('in-viewport');
        }, 150 * index);
      }
    )
  }

  reapply = () => {
    Array.prototype.forEach.call(
      this.element.querySelectorAll('.kb-enabled'),
      (el) => {
        if (el.classList.contains('in-viewport')) {
          // Reapply ken burns with a slight delay.
          el.classList.add('no-anim');
          el.classList.remove('in-viewport');
          setTimeout(() => {
            el.classList.remove('no-anim');
            el.classList.add('in-viewport');
          }, 150);
        }
      },
    );
  }
}
